import { render, staticRenderFns } from "./TourComplaint.vue?vue&type=template&id=d19caeda&"
import script from "./TourComplaint.vue?vue&type=script&lang=js&"
export * from "./TourComplaint.vue?vue&type=script&lang=js&"
import style0 from "./TourComplaint.vue?vue&type=style&index=0&id=d19caeda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports